import { useEffect, useState } from "react";
import { api, PHONE } from "../lib/api";
import { useSEO } from "../lib/useSEO";
import { Reveal } from "../components/Reveal";
import { Breadcrumbs, CtaBand } from "../components/Shared";
import { PhoneBox } from "../components/Layout";
import { ArticleCard } from "../components/ArticlesTeaser";

export default function Blog() {
  const [articles, setArticles] = useState([]);
  useSEO({ title: "Conseils & actualités serrurerie — Sécurité & prévention cambriolage (77)", description: `Conseils d'un serrurier en Seine-et-Marne : prévention des cambriolages, choix de serrure, entretien, blindage. Actualités et guides pratiques ☎ ${PHONE}.`, path: "/conseils" });
  useEffect(() => { api.get("/articles").then((r) => setArticles(r.data)).catch(() => {}); }, []);

  return (
    <div className="bg-white">
      <section className="relative pt-32 pb-16 sm:pt-36 hero-grid">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <Breadcrumbs items={[{ label: "Accueil", to: "/" }, { label: "Conseils" }]} />
          <Reveal>
            <p className="overline mb-4">Le blog du serrurier</p>
            <h1 className="text-4xl sm:text-6xl font-display font-semibold tracking-tighter leading-[0.95] max-w-4xl text-zinc-900">Conseils sécurité & prévention des cambriolages</h1>
            <p className="text-lg text-zinc-600 mt-8 max-w-2xl leading-relaxed">Guides pratiques, bons réflexes et actualités pour protéger votre logement en Seine-et-Marne : serrures, blindage, entretien et prévention.</p>
            <div className="mt-8"><PhoneBox /></div>
          </Reveal>
        </div>
      </section>
      <section className="relative z-10 py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((a, i) => <ArticleCard key={a.slug} a={a} delay={(i % 3) * 0.06} />)}
        </div>
      </section>
      <CtaBand />
    </div>
  );
}
